<template>
  <v-layout row wrap v-if="isDataLoaded">
    <v-flex xs12 v-for="(day, ix) in currentDays" :key="ix" pa-0>
      <v-card pa-0 flat>
        <v-card-title class="pa-0 cardTitle" :class="!isFutureDate(day.date) ? 'grey lighten-3': ''">
          <v-layout row wrap pa-1 pb-1>
            <v-flex xs4 pt-1 pl-1>
              <h2 class="subheading" :title="titleLabel(day.date)">{{ dayLabel(day.date) }}</h2>
            </v-flex>
            <v-flex xs6 pl-1>
              <v-btn :color="isSlotSelected(day, 1)" class="white--text mr-1 contactbtn" fab depressed small>
                <v-icon size="26">account_circle</v-icon>
              </v-btn>
              <v-btn :color="isSlotSelected(day, 2)" class="white--text mr-1 contactbtn" fab depressed small>
                <v-icon size="26">account_circle</v-icon>
              </v-btn>
              <v-btn :color="isSlotSelected(day, 3)" class="white--text mr-1 contactbtn" fab depressed small>
                <v-icon size="26" dark>account_circle</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs1 pt-1>
              <h3 class="subheading">{{day.volunteers.length || 0}}/3</h3>
            </v-flex>
            <v-spacer/>
            <v-flex xs1 pt-1 text-xs-center v-show="isFutureDate(day.date) && selectedDates.length < 30">
              <v-btn v-show="day.volunteers.length < 3 || isSelected(day.date)" :color="isSelected(day.date) ? 'red' : 'info'" class="white--text datebtn" fab depressed small title="Select this date for track duty" @click="setDate(day.date)">
                <v-icon size="20">{{isSelected(day.date) ? 'remove' : 'add'}}</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MonthRoster',
  props: {
    currentYear: String,
    currentMonth: String,
    userId: String
  },
  computed: {
    ...mapGetters({
      roster: 'getRoster',
      isRosterLoaded: 'isRosterLoaded'
    }),
    isDataLoaded () {
      return (this.year && this.month && this.isRosterLoaded)
    },
    year () {
      if (this.currentYear !== undefined & this.currentYear !== null) {
        return this.currentYear
      }

      return null
    },
    month () {
      if (this.currentMonth !== undefined & this.currentMonth !== null) {
        return this.currentMonth
      }

      return null
    }
  },
  data () {
    return {
      forceRender: true,
      currentDate: new Date().getDate(),
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      selectedDates: [],
      currentDays: []
    }
  },
  methods: {
    ...mapActions([
      'loadRoster',
      'updateRosterStore',
      'getRosterMonth'
    ]),
    isSlotSelected (day, slotNo) {
      if (this.isSelected(day.date) && slotNo === day.volunteers.length) return 'success'
      if (slotNo <= day.volunteers.length) return 'orange'
      return 'grey lighten-1'
    },
    hasRosterGotData: function (day) {
      return (this.roster[day.year] && this.roster[day.year][day.month] && this.roster[day.year][day.month][day.day])
    },
    isSelected (date) {
      return (this.selectedDates.indexOf(date) >= 0)
    },
    async generateList (passedYear = null, passedMonth = null) {
      console.log('Generating Month list...')
      if (!this.isDataLoaded) {
        console.log('Roster Not Loaded: retrieving data...')
        await this.loadRoster()
      }

      const year = passedYear !== null ? passedYear : this.year
      const month = passedMonth !== null ? passedMonth : this.month

      if (!this.roster[year]) this.roster[year] = {}
			if (!this.roster[year][month]) this.roster[year][month] = {}

      const roster = this.roster[year][month] || {}

      let last = new Date(year, Number(month) + 1, 0).getDate()
      let days = []
      let setDays = Object.keys(roster)

      for (var i = 1; i <= last; i += 1) {
        let today = new Date(year, month, i)
        if (today.getDay() !== 0 && today.getDay() !== 6) continue
      
        const newday = {
          date: today.toDateString(),
          volunteers: []
        }

        if (setDays.length > 0 && setDays.indexOf(`${today.getDate()}`) >= 0) {
          newday.volunteers = roster[`${today.getDate()}`].volunteers
        }

        days.push(newday)
      }

      this.currentDays = days
    },
    isFutureDate (date) {
      let now = new Date(new Date().toDateString())
      let check = new Date(new Date(date).toDateString())
      return (check >= now.getTime())
    },
    async setDate (date) {
      console.log('New Date Selected: ', date)
      let selected = null
      this.currentDays.map((item, ix) => {
        if (item.date === date) selected = ix
      })

      // Add/Remove selected Date from selectedDate List
      let index = this.selectedDates.indexOf(date)
      if (index === -1) this.selectedDates.push(date)
      else this.selectedDates.splice(index, 1)

      const result = await this.updateRosterStore({ timestamp: date, isSelected: (index >= 0) })
      if (selected !== null) this.currentDays[selected].volunteers = result.volunteers
      this.$emit('setDate', this.selectedDates)

      return true
    },
    dayLabel: function (date) {
      let day = new Date(date)
      let suffix = 'th'
      if ([1, 21, 31].indexOf(day.getDate()) >= 0) suffix = 'st'
      if ([2, 22].indexOf(day.getDate()) >= 0) suffix = 'nd'
      if ([3, 23].indexOf(day.getDate()) >= 0) suffix = 'rd'
      return `${this.days[day.getDay()]} ${day.getDate()}${suffix}`
    },
    titleLabel: function (date) {
      let day = new Date(date)
      let suffix = 'th'
      const months = this.months
      if ([1, 21, 31].indexOf(day.getDate()) >= 0) suffix = 'st'
      if ([2, 22].indexOf(day.getDate()) >= 0) suffix = 'nd'
      if ([3, 23].indexOf(day.getDate()) >= 0) suffix = 'rd'
      return `${this.days[day.getDay()]}, ${day.getDate() + suffix} ${months[day.getMonth()]} ${day.getFullYear()}`
    }
  },
  created () {
    this.generateList()
  }
}
</script>
<style scoped>
.contentwrap {
  border-top: none;
  border: solid 1px lightgrey;
}
.cardTitle.attention {
  border-left: solid 5px orange;
}
.datebtn {
  height: 20px;
  width: 20px;
  margin: 0;
}
.contactbtn {
  height: 26px;
  width: 26px;
  margin: 0;
}
</style>
